import Vue from 'vue'
import Vuex from 'vuex'

import {moduleInquiry} from "./modules/inquiry"
import {moduleMember, moduleBuy} from "./memberBuyStore"
import {moduleBuyState} from "./modules/buyState"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        inquiry: moduleInquiry,
        member: moduleMember,
        buy: moduleBuy,
        buyState: moduleBuyState
    }
})